import { render, staticRenderFns } from "./AffiliatesStatistics.vue?vue&type=template&id=5a3f9246&scoped=true&"
import script from "./AffiliatesStatistics.vue?vue&type=script&lang=js&"
export * from "./AffiliatesStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3f9246",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a3f9246')) {
      api.createRecord('5a3f9246', component.options)
    } else {
      api.reload('5a3f9246', component.options)
    }
    module.hot.accept("./AffiliatesStatistics.vue?vue&type=template&id=5a3f9246&scoped=true&", function () {
      api.rerender('5a3f9246', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/affiliates/Statistics/AffiliatesStatistics.vue"
export default component.exports